var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "igc-frame",
    { staticClass: "ig-index" },
    [
      _c("igc-tabs", {
        staticClass: "ig-background--tabs",
        class: { "ig--hidden": _vm.translate },
        attrs: { tabs: _vm.labels, active: _vm.activeTab },
        on: { "switch-tab": _vm.switchTab }
      }),
      _vm.activeTabInfo.label && _vm.activeTabInfo.label.length > 0
        ? _c("igc-subtab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeTabInfo.label.length > 1,
                expression: "activeTabInfo.label.length > 1"
              }
            ],
            staticClass: "ig--subtab",
            class: { "ig--hidden": _vm.translate },
            attrs: { tab: _vm.activeTabInfo, active: _vm.activeSubTab },
            on: { "switch-tab": _vm.switchSubTab }
          })
        : _vm._e(),
      _vm.showLabelInfo
        ? _c("igc-label", {
            staticClass: "ig--label",
            class: { "ig--offset": _vm.translate, "ig--height": _vm.spread },
            attrs: { label: _vm.activeSubTab, tab: _vm.active },
            on: {
              "update:tab": function($event) {
                _vm.active = $event
              }
            },
            nativeOn: {
              touchstart: function($event) {
                return _vm.touchstartEvent($event)
              },
              touchend: function($event) {
                return _vm.touchendEvent($event)
              }
            }
          })
        : _c(
            "sui-scroll",
            { staticClass: "ig--scroll", on: { reachEnd: _vm.getV4List } },
            [
              this.activeTabInfo.ad
                ? _c("igc-ad", {
                    staticClass: "ig--item",
                    attrs: { id: this.activeTabInfo.ad }
                  })
                : _vm._e(),
              this.activeTabInfo.notice
                ? _c("igc-notice", {
                    staticClass: "ig--item",
                    attrs: { notice: this.activeTabInfo.notice }
                  })
                : _vm._e(),
              _vm.activeSubTabInfo && _vm.activeSubTabInfo.url
                ? _c("igc-item-banner", {
                    staticClass: "ig--item",
                    attrs: {
                      url: _vm.activeSubTabInfo.url,
                      id: _vm.activeSubTabInfo.id
                    }
                  })
                : _vm._e(),
              _vm._l(_vm.V4List, function(item) {
                return [
                  item.iInfoType == 2
                    ? _c("igc-v4-video", {
                        key: item.works_id,
                        staticClass: "ig--item",
                        attrs: { item: item }
                      })
                    : _vm._e(),
                  item.iInfoType == 1
                    ? _c("igc-v4-news", {
                        key: item.works_id,
                        staticClass: "ig--item",
                        attrs: { item: item }
                      })
                    : _vm._e()
                ]
              }),
              _c("sui-load", {
                attrs: { color: _vm.mColor(3), more: _vm.more }
              })
            ],
            2
          ),
      _vm.ballOn.on ? _c("igc-ball", { attrs: { ball: _vm.ballOn } }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }